@if (items) {
  <div>
    <vip-paginator
      [paginator]="orderItemService.paginator"
      (pageChanged)="setPaginator($event)"
      [requesting]="orderItemService.loading"
    ></vip-paginator>
    <cdk-table-component
      [displayColumns]="displayColumns"
      [entities]="tableEntities"
      [dataSource]="dataSource"
      (rowClickAction)="viewEntry($event)"
    ></cdk-table-component>
  </div>
}
